<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกลุ่ม Device ใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ hardwareGroupInit.hardware_group_code }} -
              {{ hardwareGroupInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              Device ในกลุ่ม
              {{ hardwareGroupInit.total_hardware }} device
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100%; overflow: auto">
        <tabs class="mt-2" @selectedTab="handleSelectedTab">
          <tab
            title="ข้อมูลทั่วไป"
            class="px-4"
            style="background-color: white"
          >
            <div>
              <label class="body-2">
                รหัสกลุ่ม Device
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="hardwareGroup.hardware_group_code"
                :rules="[
                  (v) => !!v || 'โปรดระบุรหัสกลุ่ม Device',
                  (v) =>
                    !v ||
                    (v && v.length <= 10) ||
                    'รหัสกลุ่ม Device ต้องน้อยกว่า 10 ตัวอักษร',
                ]"
                outlined
                dense
                required
                clearable
                @change="checkEmpty($event, 'hardware_group_code')"
              >
              </v-text-field>
            </div>
            <div>
              <label class="body-2">
                คำอธิบาย (ไทย)
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="hardwareGroup.title_th"
                :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
                outlined
                dense
                required
                clearable
                @change="checkEmpty($event, 'title_th')"
              >
              </v-text-field>
            </div>
            <div>
              <label class="body-2"> คำอธิบาย (อังกฤษ) </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="hardwareGroup.title_en"
                outlined
                dense
                clearable
                @change="checkEmpty($event, 'title_en')"
              >
              </v-text-field>
            </div>
          </tab>
          <tab
            title="Device ในกลุ่ม"
            class="pt-0 px-4"
            style="background-color: white"
          >
            <div v-if="formAction === 'add' && !isShowHardwareGroupAdd">
              กรุณาเพิ่มข้อมูลทั่วไปก่อน
            </div>
            <div v-else>
              <div
                v-if="
                  uiCtrl && !uiCtrl.isEnable('tab:::hardware_group:member:list')
                "
              >
                ไม่มีสิทธิ์เข้าถึงข้อมูล
              </div>
              <div v-else>
                <div>
                  <v-row>
                    <v-col cols="12" lg="6">
                      <label class="caption">ค้นหา</label>
                      <v-text-field
                        v-model="search"
                        class="fix-google-chrome"
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        dense
                        clearable
                        @input="handleSearchHardware"
                        hide-details
                      >
                      </v-text-field
                    ></v-col>
                    <v-col cols="12" lg="6">
                      <label class="caption">รุ่นของ Device</label>
                      <v-autocomplete
                        v-model="hardwareModelFilter"
                        class="fix-google-chrome"
                        :items="hardwareModels"
                        item-text="title"
                        item-value="hardware_model_code"
                        hide-details
                        outlined
                        dense
                        clearable
                        @change="handleFilterHardwareModel"
                      >
                      </v-autocomplete
                    ></v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col cols="6">
                      <button
                        :disabled="
                          uiCtrl &&
                          !uiCtrl.isEnable('btn:::hardware_group:member:create')
                        "
                        type="button"
                        @click="$emit('onClickAddHardware')"
                      >
                        <v-icon left small color="primary">mdi-plus</v-icon>
                        <span class="caption primary--text"
                          >เพิ่ม Device ในกลุ่ม</span
                        >
                      </button>
                    </v-col>
                    <v-col class="py-0" cols="6">
                      <v-select
                        style="font-size: 14px"
                        v-model="sort"
                        :disabled="pagination.isLoading"
                        prepend-inner-icon="mdi-sort-ascending"
                        :items="sorts"
                        hide-details
                        @change="handleChangeSort"
                      ></v-select>
                    </v-col>
                  </v-row>
                </div>
                <DynamicScroller
                  :items="hardwaresGroupMember"
                  :min-item-size="pagination.limit"
                  key-field="hardware_uuid"
                >
                  <template v-slot="{ item, index, active }">
                    <DynamicScrollerItem
                      :item="item"
                      :active="active"
                      :data-index="index"
                    >
                      <div class="py-1">
                        <v-card
                          color="#f5f5f5"
                          outlined
                          class="d-flex align-center"
                          v-observe-visibility="
                            item.hardware_uuid === lastHardware.hardware_uuid &&
                            !isLastPage
                              ? infiniteScrollHandler
                              : false
                          "
                        >
                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title>
                                <span
                                  class="d-inline-block text-truncate"
                                  style="max-width: 360px"
                                >
                                  {{ item.hardware_code }} - {{ item.title_th }}
                                </span>
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                <span
                                  class="d-inline-block text-truncate"
                                  style="max-width: 360px"
                                >
                                  รุ่น : {{ item.hardware_model.title }}
                                </span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <div class="px-2">
                            <v-btn
                              :disabled="
                                (uiCtrl &&
                                  !uiCtrl.isEnable(
                                    'btn:::hardware_group:member:delete'
                                  )) ||
                                item.is_policy_dpc === false
                              "
                              icon
                              @click="handleDeleteHardwareGroupMember(item)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </v-card>
                      </div>
                    </DynamicScrollerItem>
                  </template>
                </DynamicScroller>
              </div>
            </div>
            <div
              v-if="
                pagination.isLoading &&
                uiCtrl &&
                uiCtrl.isEnable('tab:::hardware_group:member:list')
              "
            >
              <div class="py-">
                <v-card
                  color="#f5f5f5"
                  v-for="num in 2"
                  :key="num"
                  outlined
                  class="px-4 py-2"
                >
                  <Skeleton width="200px" />
                  <Skeleton :count="1" />
                </v-card>
              </div>
            </div>
          </tab>
        </tabs>
      </div>
      <v-toolbar flat color="blue-grey lighten-4" v-if="selectedTab === 0">
        <v-row
          justify="center"
          align="center"
          v-if="
            (!isHardwareGroupDataChange && formAction === 'edit') ||
            (formAction === 'add' && isShowHardwareGroupAdd)
          "
        >
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::hardware_group:delete')
            "
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::hardware_group:create')
            "
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::hardware_group:update')
            "
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteMember"
      :loading="confirmDialogDeleteLoadingMember"
      :dialogData="confirmDialogDeleteDataMember"
      @cancelConfirmDialog="cancelConfirmDialogDeleteMember"
      @submitConfirmDialog="submitConfirmDialogDeleteMember"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
    Tab,
    Tabs,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    hardwareGroup: {
      type: Object,
    },
    hardwareGroupInit: {
      type: Object,
    },
  },
  watch: {
    hardwareGroup(item) {
      if (item.hardware_group_uuid) {
        this.hardwaresGroupMember = []
        this.pagination.currentPage = 1
        this.getHardwaresGroupMember()
      }
    },
  },
  data() {
    return {
      selectedTab: 0,
      isShowHardwareGroupAdd: false,
      hardwareModelFilter: '',
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      hardwaresGroupMember: [],
      totalHardwaresGroupMember: 0,
      sort: 'hardware_code,asc',
      sorts: [
        { id: 1, text: 'เรียงตามรหัส', value: 'hardware_code,asc' },
        { id: 2, text: 'เรียงตามชื่อ (a - z)', value: 'title_th,asc' },
      ],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDeleteMember: false,
      confirmDialogDeleteLoadingMember: false,
      confirmDialogDeleteDataMember: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    lastHardware() {
      const [lastItem] = this.hardwaresGroupMember.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalHardwaresGroupMember / this.pagination.limit)
      )
    },
    hardwareModels() {
      return this.$store.state.hardware.hardwareModels.filter((h) =>
        [
          'acu81',
          'acu81r',
          'tat51i',
          'cru77rf',
          'q3rac',
          'vf600',
          'vf1000',
          'vf1000r',
          'acu01r',
          'cru67rc',
          'cru67rf',
        ].includes(h.hardware_model_code)
      )
    },
    isHardwareGroupDataChange() {
      if (
        this.hardwareGroup.hardware_group_code !==
          this.hardwareGroupInit.hardware_group_code ||
        this.hardwareGroup.title_th !== this.hardwareGroupInit.title_th ||
        this.hardwareGroup.title_en !== this.hardwareGroupInit.title_en
      ) {
        this.$emit('isHardwareGroupDataChange', true)
        return true
      }
      this.$emit('isHardwareGroupDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      fetchHardwaresGroupMember: 'hardwaresGroup/fetchHardwaresGroupMember',
      deleteHardwareGroupMember: 'hardwaresGroup/deleteHardwareGroupMember',
      addHardwareGroup: 'hardwaresGroup/addHardwareGroup',
      editHardwareGroup: 'hardwaresGroup/editHardwareGroup',
      deleteHardwareGroup: 'hardwaresGroup/deleteHardwareGroup',
    }),
    handleSelectedTab(i) {
      this.selectedTab = i
    },
    handleDeleteHardwareGroupMember(item) {
      this.confirmDialogDeleteMember = true
      this.confirmDialogDeleteDataMember = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ Device',
        value: `${item.title_th}`,
        item,
      }
    },
    cancelConfirmDialogDeleteMember() {
      this.confirmDialogDeleteMember = false
    },
    async submitConfirmDialogDeleteMember({ hardware_uuid }) {
      try {
        this.search = ''
        this.confirmDialogDeleteLoadingMember = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_group_uuid: this.hardwareGroup.hardware_group_uuid,
          hardware_uuid,
          params: {
            dpc: 'access-hardware-group-post-delete-to-list-access-hardware-group',
          },
        }

        await this.deleteHardwareGroupMember(payload)
        this.confirmDialogDeleteLoadingMember = false
        this.confirmDialogDeleteMember = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.hardwaresGroupMember = []
        this.pagination.currentPage = 1
        await this.getHardwaresGroupMember()
        this.$store.commit('hardwaresGroup/EDIT_HARDWARE_GROUP', {
          ...this.hardwareGroup,
          hardware_group_member: {
            ...this.hardwareGroup.hardware_group_member,
            total: this.totalHardwaresGroupMember,
          },
        })
      } catch (error) {
        this.confirmDialogDeleteLoadingMember = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleFilterHardwareModel() {
      this.hardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getHardwaresGroupMember()
    },
    handleSearchHardware: _.debounce(function () {
      // if (this.search === undefined || this.search === null) return
      this.hardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getHardwaresGroupMember()
    }, 1000),
    handleChangeSort() {
      this.hardwaresGroupMember = []
      this.pagination.currentPage = 1
      this.getHardwaresGroupMember()
    },
    async getHardwaresGroupMember() {
      try {
        if (
          this.uiCtrl &&
          !this.uiCtrl.isEnable('tab:::hardware_group:member:list')
        ) {
          return
        }

        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_group_uuid: this.hardwareGroup.hardware_group_uuid,
          params: {
            dpc:
              this.uiCtrl &&
              (this.uiCtrl.isEnable('btn:::hardware_group:member:delete') ||
                this.uiCtrl.isEnable('btn:::hardware_group:member:create'))
                ? 'access-hardware-group-post-delete-to-list-access-hardware-group'
                : 'access-hardware-group-to-list-access-hardware-group',
            hardware_model_code: this.hardwareModelFilter || undefined,
            search: this.search || undefined,
            sort: this.sort,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
            is_policy_tag: true,
          },
        }
        const { total: totalHardwaresGroupMember, data: hardwaresGroupMember } =
          await this.fetchHardwaresGroupMember(payload)
        this.totalHardwaresGroupMember = totalHardwaresGroupMember
        this.setHardwaresGroupMember(hardwaresGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextHardwaresGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getHardwaresGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setHardwaresGroupMember(hardwaresGroupMember) {
      this.hardwaresGroupMember = [
        ...this.hardwaresGroupMember,
        ...hardwaresGroupMember,
      ]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextHardwaresGroupMember()
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.hardwareGroup[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบกลุ่ม Device',
        value: this.hardwareGroup.title_th,
        item: this.hardwareGroup,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete({ hardware_group_uuid }) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        hardware_group_uuid,
      }

      this.deleteHardwareGroup(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
          this.$refs.form.resetValidation()
          this.sort = 'hardware_code,asc'
          this.hardwaresGroupMember = []
          this.isShowHardwareGroupAdd = false
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: {
              hardware_group_code: this.hardwareGroup.hardware_group_code,
              title_th: this.hardwareGroup.title_th,
              title_en: this.hardwareGroup.title_en || undefined,
            },
          }

          const hardwareGroup = await this.addHardwareGroup(payload)
          this.$emit('addHardwareGroupSuccess', hardwareGroup)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.isShowHardwareGroupAdd = true
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            hardware_group_uuid: this.hardwareGroup.hardware_group_uuid,
            body: {
              hardware_group_code: this.hardwareGroup.hardware_group_code,
              title_th: this.hardwareGroup.title_th,
              title_en: this.hardwareGroup.title_en || undefined,
            },
          }

          await this.editHardwareGroup(payload)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
          this.$refs.form.resetValidation()
          this.sort = 'hardware_code,asc'
          this.hardwaresGroupMember = []
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    onClose() {
      if (this.isHardwareGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        // this.$refs.form.reset()
        this.$refs.form.resetValidation()
        this.sort = 'hardware_code,asc'
        this.hardwaresGroupMember = []
        this.isShowHardwareGroupAdd = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.sort = 'hardware_code,asc'
      this.hardwaresGroupMember = []
      this.isShowHardwareGroupAdd = false
    },
    onReset() {
      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.sort = 'hardware_code,asc'
      this.isShowHardwareGroupAdd = false
    },
  },
}
</script>
